module.exports = __webpack_public_path__ + "img/usa-diseases-of-the-nervous-system-female.9046261f.png";